export default __webpack_public_path__ + "static/media/pull-request.129c916a.svg";